// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"73dea08e","787":"bbc2f113","901":"131e3aaa"}[chunkId] + ".chunk.js";
};